import React from 'react';
import { ReportWorkspace } from './reporting/ReportWorkspace';
export default function LivroDeClassePage() { return <ReportWorkspace report="livro-classe" />; }